import { Injectable } from '@angular/core';
import { IStoreBase } from '@boxx/core';
import {
  ProfileModel,
  IProfileStateSuccess,
  IProfileStateError,
} from '@boxx/profile-core';
import { Store } from '@ngrx/store';
import * as fromActions from './profile.actions';
import * as fromReducer from './profile.reducer';
import * as fromSelector from './profile.selectors';

@Injectable()
export class ProfileStore
  implements IStoreBase<ProfileModel, IProfileStateSuccess, IProfileStateError>
{
  constructor(private store: Store<fromReducer.ProfileState>) {}

  get loading$() {
    return this.store.select(fromSelector.getIsLoading);
  }

  get error$() {
    return this.store.select(fromSelector.getError);
  }

  get success$() {
    return this.store.select(fromSelector.getSuccess);
  }
  get fetched$() {
    return this.store.select(fromSelector.fetched);
  }

  get data$() {
    return this.store.select(fromSelector.getProfile);
  }

  fetch() {
    return this.store.dispatch(fromActions.loadProfileBeginAction());
  }

  update(profileForm: { name: string; email: string }) {
    return this.store.dispatch(
      fromActions.updateProfileBeginAction({ profileForm })
    );
  }
}
